import React, { ReactElement } from 'react';

import CustomMetatag from '@/components/layouts/custom-metatag';
import Layout from '@/components/layouts/lcv';
import Register, { IRegister } from '@/components/sections/register';
import { TISL_REGISTER_DATA } from '@/contents/lcv/register';

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default function Page() {
  const { entry } = TISL_REGISTER_DATA;

  const REGISTER_DATA: IRegister = {
    campaignName: entry?.name,
    campaignId: entry?.uid,
    campaignVersion: entry?._version,
    title: 'ចូលបំពេញព័ត៌មានរបស់អ្នក ដើម្បីឱ្យក្រុមការងាររអាចទាក់ទងអ្នកឆាប់ៗ',
    successURL: '/register/thankyou',
    imgMobileURL:
      'https://assets.tripetchgroup.com/tripetchgroup-cms-prd/register_bg_mobile_f72c7a6e8a.jpg',
    imgDesktopURL:
      'https://assets.tripetchgroup.com/tripetchgroup-cms-prd/register_bg_desktop_4c071a31fc.jpg',
    isNameAndTel: false,
    lcvModel: '',
    vehicleType: 'lcv',
    showVehicleType: true,
  };

  return (
    <>
      {!!(
        entry?.metatag?.title ||
        entry?.metatag?.description ||
        entry?.metatag?.img?.url
      ) && (
        <CustomMetatag
          title={entry?.metatag?.title}
          description={entry?.metatag?.description}
          imgURL={entry?.metatag?.img?.url}
        />
      )}
      <Register {...REGISTER_DATA} lcvModel={'pickup'} />
    </>
  );
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};
